import template from './editor.html';
import controller from './editor.controller';

let editorComponent = {
    template: template,
    controller: controller,
    controllerAs: 'editorCtrl'
  };

export default editorComponent;
